<ul class="list-group address-list">
    @for (addy of addresses; track addy.id; let index = $index) {
        <li class="list-group-item">
            @if (!addy.editing) {
                <span class="material-icons icon" [ngClass]="{'primary': addy.primaryAddress}">{{addyIcon(addy.addressType.type)}}</span>
                <div class="meta" (click)="editAddress($event, index)">
                    <p class="title">{{addy.address}}</p>
                    <p class="subtitle">{{addy.city | titlecase}}, {{addy.state | uppercase}} {{addy.zipCode}}</p>
                </div>
                <div class="actions actions-1">
                    <span class="dripicons-trash text-danger" (click)="discardAddress($event, index)"></span>
                </div>
            }
            @else {
                <form [formGroup]="addressEdit">
                    <div class="form-row">
                        <div class="form-group col">
                            <select class="form-control form-control-sm" formControlName="addressTypeId">
                                @for (type of addressTypes; track type.id) {
                                    <option value="{{type.id}}">{{type.type}}</option>
                                }
                            </select>
                        </div>
                        <div class="form-group col-xs-3">
                            <select class="form-control form-control-sm" formControlName="status">
                                @for (ownership of addressOwnerships; track ownership) {
                                    <option value="{{ownership}}">{{ownership}}</option>
                                }
                            </select>
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="text" class="form-control form-control-sm" formControlName="address" placeholder="street address" />
                    </div>
                    <div class="form-row">
                        <div class="form-group col">
                            <input type="text" class="form-control form-control-sm" formControlName="address2" placeholder="apt. #, suite, etc..." />
                        </div>
                        <div class="form-group col">
                            <input type="text" class="form-control form-control-sm" formControlName="zipCode" placeholder="zip code" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-check col">
                            <input type="checkbox" id="addressPrimary" class="form-check-input" formControlName="primaryAddress" />
                            <label class="form-check-label" for="addressPrimary">Primary</label>
                        </div>
                        <p class="col location">{{location}}</p>
                    </div>
                    <div class="form-row">
                        <div class="actions col">
                            <button type="button" class="btn btn-sm btn-link" (click)="cancelAddress($event)"><span class="text-danger">cancel</span></button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="saveAddress($event)">Save</button>
                        </div>
                    </div>
                </form>
            }
        </li>
    }
</ul>
<button (click)="addAddress($event)" title="Add Address" class="btn btn-sm btn-success add"><span class="uil-plus"></span></button>